import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStopwatch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "stopwatch" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 14.001,
			r: 9.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9,
			y1: .501,
			x2: 15,
			y2: .501
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18.717,
			y1: 7.284,
			x2: 20.5,
			y2: 5.501
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "10.5 4.618 10.5 0.501 13.5 0.501 13.5 4.619"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20,
			y1: 5.001,
			x2: 21,
			y2: 6.001
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 14.001,
			x2: 7.5,
			y2: 9.501
		})
	]
});
export default SvgStopwatch;
